let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("fGT64"), load("lE3cg")]).then(() => parcelRequire('dp2qz'));